var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimplazIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 10.5V10.6H9H16.275C17.8305 10.6 19.1 9.43497 19.1 8V5.5V5.4H19H11.725C10.1695 5.4 8.9 6.56503 8.9 8V10.5ZM17.9875 8C17.9875 8.85587 17.2289 9.57442 16.2624 9.57442H9.9872V8C9.9872 7.14413 10.7458 6.42558 11.7123 6.42558H17.9875V8Z",
    fill: "#303030",
    stroke: "#303030",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.4H4.9V13.5V16C4.9 17.4439 6.1359 18.6 7.62882 18.6H19H19.1V18.5V16C19.1 14.5561 17.8641 13.4 16.3712 13.4H5ZM5.98035 14.4372H16.3834C17.2994 14.4372 18.0441 15.1417 18.0441 16.0116V17.586H7.64105C6.72508 17.586 5.98035 16.8815 5.98035 16.0116V14.4372Z",
    fill: "#303030",
    stroke: "#303030",
    strokeWidth: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 1.75,
    width: 20.5,
    height: 20.5,
    rx: 3.25,
    stroke: "#303030",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplazIcon);
export default __webpack_public_path__ + "static/media/simplaz_icon.ad188710d6dce933a8d4ac293464f295.svg";
export { ForwardRef as ReactComponent };